import { render, staticRenderFns } from "./appFileUploader3.vue?vue&type=template&id=10708400"
import script from "./appFileUploader3.vue?vue&type=script&lang=js"
export * from "./appFileUploader3.vue?vue&type=script&lang=js"
import style0 from "./appFileUploader3.vue?vue&type=style&index=0&id=10708400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports